// extracted by mini-css-extract-plugin
export default {"menuWrapper":"styles_menuWrapper__TIkZw","leaveButton":"styles_leaveButton__LLPPS"};